import { useParams } from 'react-router-dom'

interface Props {
};

export function CategoryView(props: Props) {
    const route = useParams()
    return (
        <div className="category">
            {route.sub_cat_name ? `sub-category of ${route.cat_name} is ${route.sub_cat_name}` : `category ${route.cat_name}`}
            <br />
            category products
        </div>
    )
}
